import { isAuthenticated } from "./Auth";

export const LOGO = "/assets/images/bddwlogo.svg";
export const SITE_NAME = "BDDW Auctions";

export const handleRedirectInternal = (history, path) => {
  if (
    path.toString().includes("http://") ||
    path.toString().includes("https://") ||
    path.toString().includes("www")
  ) {
    if (
      path.toString().includes("www.") &&
      !path.toString().includes("http://") &&
      !path.toString().includes("https://")
    ) {
      var new_path = "https://" + path;
      window.open(new_path);
    } else {
      window.open(path);
    }
  } else {
    if (path == "dashboard" && !isAuthenticated()) {
      path = "login";
    }
    history.push(`/${path}`);
    window.scrollTo(0, 0);
  }
};
export const onImageError = (e, status = "", ava = "", error_count = 0) => {
  if (status == "open" && error_count == 1 && ava) {
    e.target.src = ava;
  } else if (status == "open" && error_count == 2) {
    e.target.src = "/assets/images/bddwlogo.svg";
  } else {
    e.target.src = "/assets/images/bddwlogo.svg";
  }
};

export const logoError = (e) => {
  if (e.target.src !== window.location.origin + LOGO) {
    e.target.src = LOGO;
  }
};
export const getnearteImages = (array, enable = 0) => {
  let product = array.map((data) => {
    let images = [];
    let ava = "";
    if (
      data?.lotImages?.length !== 0 &&
      data?.lotImages?.length !== undefined
    ) {
      //ava = `${process.env.REACT_APP_PRODUCT_IMG}${process.env.REACT_APP_SITE_ID}/${data.auctionlot_title}/${data.productImagesName[0]}`

      const filteredImages = data.lotImages.filter(
        (img, i) =>
          !(
            i === 0 &&
            img?.attach_type === "MysteryPriceImage" &&
            data?.market_status === "open"
          ),
      );

      ava = data?.market_status
        ? imageToImagekitURL(filteredImages[0].file_name, data?.market_status)
        : filteredImages[0].file_name;
      images = data.lotImages
        .filter(
          (img, i) =>
            !(
              i === 0 &&
              img?.attach_type === "MysteryPriceImage" &&
              data?.market_status === "open"
            ),
        )
        .map((img, i) => {
          //let image = `${process.env.REACT_APP_PRODUCT_IMG}${process.env.REACT_APP_SITE_ID}/${data.auctionlot_title}/${img}`
          if (img.file_name) {
            // let image = img.file_name;

            let image = data?.market_status
              ? imageToImagekitURL(img.file_name, data?.market_status)
              : img.file_name;
            // if (
            //   !img.file_name.toString().includes("amazon") &&
            //   !img.file_name.toString().includes("bddwauctions")
            // ) {
            //   ava = `${process.env.REACT_APP_PRODUCT_IMG}/${data.lotImages[0].file_name}`;
            //   image = `${process.env.REACT_APP_PRODUCT_IMG}/${img.file_name}`;
            // }
            return {
              original: image,
              thumbnail: image,
              attach_type: img?.attach_type,
            };
          }
        });
    } else if (
      data?.productImagesName?.length !== 0 &&
      data?.productImagesName?.length !== undefined
    ) {
      ava = `${process.env.REACT_APP_PRODUCT_IMG}${process.env.REACT_APP_SITE_ID}/${data.auctionlot_title}/${data.productImagesName[0]}`;
      //ava=data.lotImages[0].file_name
      images = data.productImagesName.map((img) => {
        let image = `${process.env.REACT_APP_PRODUCT_IMG}${process.env.REACT_APP_SITE_ID}/${data.auctionlot_title}/${img}`;
        //let image =img.file_name
        return { original: image, thumbnail: image };
      });
    } else {
      images = [{ original: "", thumbnail: "", attach_type: "" }];
    }
    if (enable == 1) {
      return {
        ...data,
        productImages: images,
        productAva: ava,
        isFav: "1",
        img_error_count: 0,
      };
    } else {
      return {
        ...data,
        productImages: images,
        productAva: ava,
        img_error_count: 0,
      };
    }
  });
  return product;
};

export const imageToImagekitURL = (inputURL, marketStatus) => {
  if (
    inputURL &&
    (inputURL.includes("s3.amazonaws.com") ||
      inputURL.includes("bddwinventory.com/assets/large") ||
      inputURL.includes("s3.us-east-2.amazonaws") ||
      inputURL.includes("s3.us-east-1.amazonaws"))
  ) {
    return inputURL
      .replace(
        "https://auc-46.s3.us-east-2.amazonaws.com",
        "https://ik.imagekit.io/6s8p3m2gj",
      )
      .replace(
        "https://auction-software.s3.amazonaws.com/bddw",
        "https://ik.imagekit.io/6s8p3m2gj",
      )
      .replace(
        "https://auc-weekly.s3.us-east-2.amazonaws.com",
        "https://ik.imagekit.io/6s8p3m2gj",
      )
      .replace(
        "https://bddwinventory.com/assets/large",
        "https://ik.imagekit.io/6s8p3m2gj",
      )
      .replace(
        "https://auction-software.s3.us-east-1.amazonaws.com/bddw",
        "https://ik.imagekit.io/6s8p3m2gj",
      );
  } else {
    return inputURL;
  }
};
